import './styles/styles.scss';
import './scripts/common.js';


/** WEBPACK FOOTER **
 ** ./src/app.js
 **/